<template>
  <fin-header-footer-container content-color="#edf1f4" footer-color="#edf1f4" header-color="#edf1f4"
                               page-color="#edf1f4" vertical-centered>
    <template #default="{ footerHeight }">
      <v-row align="center" class="mx-0" justify="center">
        <v-col cols="12" style="max-width: 800px">
          <h1 style="text-align: center; font-size: 32px;" v-html="header"/>

          <v-row>
            <v-col>
              <v-img :height="125"
                     :src="require('@/assets/onboarding/registration/'+ img.src + '.svg')" :width="img.width"
                     class="my-5"
                     contain style="margin: 0 auto;"/>
            </v-col>
            <v-col align-self="center">
              <template v-if="error">
                <fin-error-msg v-if="!showResend"
                               :msg="errorText"
                               style="background-color: #edf1f4 !important;"/>
                <fin-info-msg v-if="showResend && !resendError"
                              msg="Dein Aktivierungslink ist abgelaufen, lasse dir einfach einen neuen zusenden."/>

                <template v-if="showResend && !resendError">
                  <v-btn outlined style="display: block; margin: 0 auto;" tile @click="resendVerificationCode">
                    Erneut senden
                  </v-btn>
                  <p class="mt-5">{{ resendText }}</p>
                  <p class="mt-2" style="text-align: center">Nichts angekommen? Überprüfe auch deinen Spam-Ordner.</p>
                </template>

                <p v-if="resendError" class="mt-5">{{ resendText }}</p>

                <p v-if="!showResend || resendError" style="font-size: 14px; text-align: center;">
                  Falls weiterhin Probleme auftreten, kontaktiere uns:
                  <br/>
                  <a href="mailto:support@fincraft.de">support@fincraft.de</a>
                </p>
              </template>

              <template v-else>
                {{ text }}
              </template>
            </v-col>
          </v-row>

          <v-row>
            <v-col align="center">
              <v-btn text to="/">Zurück zur Startseite</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </fin-header-footer-container>
</template>

<script>
import FinHeaderFooterContainer from "@/components/common/HeaderFooterContainer"
import {confirmNewsletterUser, resendConfirmationLink} from "@/js/finMutations"
import {Analytics, API} from "@/plugins/finAmplifyModules"
import FinErrorMsg from "@/components/common/ErrorMsg"
import FinInfoMsg from "@/components/common/InfoMsg"
import { mapGetters } from "vuex"

export default {
  name: "finNewsletterVerify",
  components: {FinInfoMsg, FinErrorMsg, FinHeaderFooterContainer},
  data() {
    return {
      header: 'Freischaltung für unsere Updates',
      text: null,
      img: {
        src: 'email-confirmation',
        width: '110'
      },
      error: false,
      errorText: null,
      token: null,
      showResend: false,
      resendText: null,
      resendError: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['publicQueryAuthMode']),
  },
  methods: {
    async verifyToken() {
      if (this.token === undefined) {
        this.error = true
        this.resendError = true
      } else {
        try {
          let confirmResult = await API.graphql({
            query: confirmNewsletterUser,
            variables: {token: this.token},
            authMode: this.publicQueryAuthMode
          })
          if (confirmResult.data.confirmNewsletterUser === 'OK') {
            this.text = 'Du bist nun für unsere Updates freigeschaltet und verpasst nichts mehr.'
          } else if (confirmResult.data.confirmNewsletterUser === 'CONFIRMED') {
            this.text = 'Deine E-Mail Adresse ist bereits für unsere Updates freigeschaltet.'
          } else if (confirmResult.data.confirmNewsletterUser === 'UNREGISTERED') {
            this.error = true
            this.errorText = 'Zu deiner E-Mail-Adresse liegt keine Registrierung vor.'
          } else if (confirmResult.data.confirmNewsletterUser === 'EXPIRED') {
            this.error = true
            this.errorText = 'Dein Aktivierungslink ist abgelaufen. Lasse dir einfach einen neuen zusenden.'
            this.showResend = true
          } else {
            console.log("ERROR verifying newsletter user token", confirmResult.data)
            this.error = true
            this.errorText = 'Fehler beim Verifizieren deines Aktivierungslinks für unsere Updates!'
          }
        } catch (error) {
          console.log("ERROR verifying newsletter user token", error, this.token)
          this.error = true
          this.errorText = 'Fehler beim Verifizieren deines Aktivierungslinks für unsere Updates!'
        }
      }
    },
    async resendVerificationCode() {
      try {
        let confirmResult = await API.graphql({
          query: resendConfirmationLink,
          variables: {
            baseURL: window.location.origin,
            token: this.token
          },
          authMode: this.publicQueryAuthMode
        })

        if (confirmResult.data.resendConfirmationLink === 'OK') {
          this.resendText = 'Es wurde dir ein neuer Aktivierungslink an deine angegebene E-Mail-Adresse geschickt.'
        } else if (confirmResult.data.resendConfirmationLink === 'CONFIRMED') {
          this.resendError = true
          this.resendText = 'Deine E-Mail Adresse ist bereits für unsere Updates freigeschaltet.'
        } else if (confirmResult.data.resendConfirmationLink === 'UNREGISTERED') {
          this.resendError = true
          this.resendText = 'Zu deiner E-Mail-Adresse liegt keine Registrierung vor.'
        } else {
          console.log("ERROR resending newsletter activation link", confirmResult.data)
          this.resendError = true
          this.resendText = 'Es trat ein Fehler auf. Versuche es erneut oder kontaktiere uns (s.u.).'
        }
      } catch (error) {
        console.log("ERROR resending newsletter activation link", error)
        this.error = true
        this.resendError = true
      }
    }
  },
  mounted() {
    this.token = this.$route.query.token

    this.verifyToken()

    Analytics.record({ name: 'newsletterVerifyVisit' })
  }
}
</script>

<style scoped>

</style>
